import _jsx from '@babel/runtime/helpers/esm/jsx';
import _noop from 'lodash/noop';
import { memo } from 'react';
import '@dbh/generic-types';
import Text from '@dbh/text';

const idText=_noop,GenericErrorMessage=/*#__PURE__*/memo(a=>{let{id:c="components.MessageErrorGeneric.default",text:b,// eslint-disable-next-line react/prop-types, camelcase, no-unused-vars
__id_text:d=idText}=a;return/*#__PURE__*/_jsx(Text,{intlFormatter:!!c,padding:"sp4"},void 0,b||c)});// A simple, generic error message for when things go really wrong and the page
// can basically do nothing. Example: a booking funnel page that requires a query
// parameter in the URL, but it's not there.
GenericErrorMessage.displayName="GenericErrorMessage";

export { GenericErrorMessage as default };
